<template>
  <div>
    <article class="con5">
      <div class="inner container">
        <p id="philPerson" class="title-text">CARROT의 인재상</p>
        <div class="text-wrapper">
          <img
            src="@/assets/img/newGlobal/introduce/sub/philosophy/con5/img.png"
            alt="img"
          />
          <p>자연성 인간</p>
          <p>
            CARROT의 인재상은 열정으로 스스로 학습 성장하는 Value Creator,
            자연성 인간이다.<br />단순히 일을 '잘하는' 것만이 중요한 것이
            아니라, 스스로 열정을 가지고 성장할 수 있는<br />전문가가 되는 것이
            CARROT 인재상의 지향점이다.
          </p>
          <div></div>
          <p>인간의 유형은 크게 3가지로 나눌 수 있다.</p>
          <p>
            1. 불연성 인간 : 잘 동기부여가 되지 않는 사람 / 세상을 보는 시각이
            부정적인 사람.<br />2. 가연성 인간 : 주로 환경적 자극에 의해서
            동기부여가 되는 사람.<br />3. 자연성 인간 : 스스로 살아서 움직이며
            도전하고 성장하는 사람.
          </p>
          <p @click="goRecruit">지원하러 가기</p>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import "@/assets/style/newGlobalReset.scss";

export default {
  methods: {
    goRecruit() {
      this.$router.push({ path: "/Recruit" });
    },
  },
};
</script>

<style lang="scss" scoped>
.con5 {
  background: url(~@/assets/img/newGlobal/introduce/sub/philosophy/con5/bg.jpg)
    no-repeat center top / cover;

  .inner {
    padding: 40px 0;

    @media screen and (min-width: 1350px) {
      padding: 80px 0;
    }

    .title-text {
      font-size: 30px;
      font-weight: 700;
      color: #ffffff;
      text-align: center;
      margin-bottom: 20px;
    }

    .text-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #ffffff;
      text-align: center;

      img {
        margin-bottom: 20px;
      }

      p {
        &:nth-of-type(1) {
          font-size: 18px;
          font-weight: 700;
          color: #fe4818;
          margin-bottom: 20px;
        }

        &:nth-of-type(4) {
          margin-bottom: 20px;
        }

        &:nth-of-type(5) {
          cursor: pointer;
        }
      }

      div {
        width: 80px;
        height: 1px;
        background-color: #ffffff;
        margin: 20px 0;
      }
    }
  }
}
</style>
